import { Stack } from '@mantine/core';

import { NAVBAR_HEIGHT } from '../../shared/components/UI/Navbar/Navbar';

import { useCreateOrEditResponseProjectPanel } from '../../features/bidResponse/components/responseProject/components/createOrEditResponseProjectPanel/hooks/useCreateOrEditResponseProjectPanel';
import { ResponseProjectPageTitle } from '../../features/bidResponse/components/responseProject/components/responseProjectList/components/ResponseProjectListPageTitle';
import { ResponseProjectTable } from '../../features/bidResponse/components/responseProject/components/responseProjectList/components/ResponseProjectTable';
import { BID_RESPONSE_SIDEBAR_WIDTH } from '../../features/bidResponse/components/sidebar/SideBar';
import { withFeatureFlag } from '../../shared/components/FeatureFlagGuard';
import { FeatureFlag } from '../../shared/entities/FeatureFlags';

export function ResponseProjectPage() {
  return withFeatureFlag(<SafeResponseProjectPage />, FeatureFlag.PRE_RELEASE);
}

function SafeResponseProjectPage() {
  const { togglePanel } = useCreateOrEditResponseProjectPanel({});
  const handleTriggerCreateProject = () => {
    togglePanel();
  };

  return (
    <Stack
      w={`calc(100vw - ${BID_RESPONSE_SIDEBAR_WIDTH}px)`}
      p="05"
      spacing="03"
      h={`calc(100vh - ${NAVBAR_HEIGHT}px)`}
      sx={{
        overflow: 'hidden',
      }}
    >
      <ResponseProjectPageTitle onCreateProject={handleTriggerCreateProject} />
      <ResponseProjectTable onCreateProject={handleTriggerCreateProject} />
    </Stack>
  );
}
